<template>
  <div v-if="showDialog" class="dialog">
    <div class="header">
      <b-nav class="tab-buttons" tabs align="left">
        <b-nav-item 
          class="tab pressure-change" 
          @click="changeTab('pressure-change')" active>
          Alteração de pressão
          </b-nav-item>
        <b-nav-item 
          class="tab currents" 
          @click="changeTab('currents')" >
          Correntes
          </b-nav-item>
        <b-nav-item 
          class="tab shapes" 
          @click="changeTab('shapes')" >
          Formas
          </b-nav-item>
        <b-nav-item 
          class="tab handlers" 
          @click="changeTab('handlers')" >
          Manipuladores
          </b-nav-item>
        <b-nav-item 
          class="tab reactors" 
          @click="changeTab('reactors')" >
          Reatores
          </b-nav-item>
        <b-nav-item 
          class="tab separators" 
          @click="changeTab('separators')" >
          Separadores
          </b-nav-item>
        <b-nav-item 
          class="tab solids" 
          @click="changeTab('solids')" >
          Sólidos
          </b-nav-item>
        <b-nav-item 
          class="tab tanks" 
          @click="changeTab('tanks')" >
          Tanques
          </b-nav-item>
        <b-nav-item 
          class="tab heat-exchanger" 
          @click="changeTab('heat-exchanger')" >
          Trocador de Calor
          </b-nav-item>
      </b-nav>
      <span class="close noselect" 
      @click="closeDialog" >x</span>
    </div>
    
    <div class="body">
      <div v-if="tabSelected == 'pressure-change'">
        <img draggable="true" @dragstart="(event) => drag(event, types.Bomb)" src="@/assets/Fluxogramas/bomba.png">
        <img draggable="true" @dragstart="(event) => drag(event, types.Line)" src="@/assets/Fluxogramas/bomba.png">
      </div>

      <div v-if="tabSelected == 'currents'">
        <img draggable="true" @dragstart="(event) => drag(event, types.Current)" src="@/assets/Fluxogramas/caixadetexto.png">
      </div>

      <div v-if="tabSelected == 'shapes'">
        formas
      </div>

      <div v-if="tabSelected == 'handlers'">
        manipuladores
      </div>

      <div v-if="tabSelected == 'reactors'">
        reatores
      </div>

      <div v-if="tabSelected == 'separators'">
        <img draggable="true" @dragstart="(event) => drag(event, types.FermentationBatch)" src="@/assets/Fluxogramas/FermentacaoBatelada.png">
      </div>

      <div v-if="tabSelected == 'solids'">
        solidos
      </div>

      <div v-if="tabSelected == 'tanks'">
        <!-- <img draggable="true" @dragstart="(event) => drag(event, types.Tank)" src="@/assets/Fluxogramas/Caleagem.png">
        <img draggable="true" @dragstart="(event) => drag(event, types.Tank)" src="@/assets/Fluxogramas/Cuba.png">
        <img draggable="true" @dragstart="(event) => drag(event, types.Tank)" src="@/assets/Fluxogramas/Tanque_de_condensado.png">
        <img draggable="true" @dragstart="(event) => drag(event, types.Tank)" src="@/assets/Fluxogramas/tanque_diluicao.png">
        <img draggable="true" @dragstart="(event) => drag(event, types.Tank)" src="@/assets/Fluxogramas/Tanque_da_Volante.png"> -->
        <img draggable="true" @dragstart="(event) => drag(event, types.Tanque)" src="@/assets/Fluxogramas/tanque.png">
      </div>

      <div v-if="tabSelected == 'heat-exchanger'">
        trocadro de calor
      </div>
    </div>
  </div>
</template>

<script>
import { Types } from "../utils/nodeTypes";



  export default {
    name:"FormOperations",

    props: [ 'dialogVisibleShow' ],
    
    data() {
      return {
        showDialog: false,
        types: new Types,
        tabSelected: "pressure-change",
      }
    },

    watch: {
      dialogVisibleShow(){
        this.showDialog = true
      },
      
    },

    methods: {
      closeDialog(){
        this.tabSelected = "pressure-change"
        this.showDialog = false
      },

      drag(event, type){
        event.dataTransfer.setData("createNode", JSON.stringify(type))
      },

      changeTab(tab){
        document.querySelectorAll(".tab>a").forEach(el => el.classList.remove('active'))
        document.querySelector(`.${tab}>a`).classList.add('active')
        this.tabSelected = tab
      }
    },

    mounted() {},
  }
</script>

<style>

</style>

<style scoped>
.dialog {
  display: flex;
  flex-direction: column;
  padding: 16px;
  position: absolute;
  top: 100px;
  left: calc(50% - 250px);
  width: 500px;
  height: 300px;
  background-color: #fff;

  border-radius: 7px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  z-index: 10;
}

.close{
  cursor: pointer;
  font-weight: bolder;
  font-size: 18px;
}

.header{
  display: flex;
  border-left: 1px solid #ff5f0080;
  border-right: 1px solid #ff5f0080;
  border-top: 1px solid #ff5f0080;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;

}

.tab-buttons{
  border-bottom: none;
}

.tab-buttons > li > a{
  padding: 3px;
  height: 30px;
  color: #0008;
  font-size: 0.8em;
}

.tab-buttons > li > a:hover{
  border: 1px solid #ff5f0020;
}

.tab-buttons > li > a.active{
  font-weight: 400;
  color: #fff;
  background: #ff5f00;
  border-left: 1px solid  #ff5f00;
  border-right: 1px solid  #ff5f00;
  border-top: 1px solid  #ff5f00;
}

.body{
  width: 100%;
  height: 100%;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #ff5f0080;
}

.body > div{
  display: flex;
  justify-content: flex-start;
  padding: 16px 8px;
}

.body img{
  width: 50px;
  height: 50px;
  padding: 3px;
  margin: 3px;
  border-radius: 4px;
  border: 1px solid #0004;
}

</style>